import React from 'react'

export const QDLions = (imageProps) => {
  return (
    <img src={require("../../assets/lion.png")} {...imageProps}></img>
  )
}